<template>
  <div
    v-if="isHistory == true"
    :class="!isMinimize ? 'divHistory' : 'divMinimize'"
  >
    <div :style="!isMinimize && 'height: calc(100vh - 9rem);'">
      <!--  border: 1px solid #fff -->
      <div
        :class="!isMinimize ? 'draggable' : 'draggableMinimize'"
        :style="isMinimize && 'left: 0px; top: 0px;'"
      >
        <div class="dragger flex justify-between">
          <div class="flex justify-end">
            <div class="mt-1 mr-2">
              <feather-icon
                v-if="!isMinimize"
                icon="MinusIcon"
                class="cursor-pointer"
                @click="isMinimize = true"
              ></feather-icon>
              <feather-icon
                v-else
                icon="MinusIcon"
                class="cursor-pointer"
                @click="isMinimize = false"
              ></feather-icon>
            </div>
            <div class="mt-1">
              <feather-icon
                icon="XIcon"
                class="cursor-pointer"
                @click="
                  onClose();
                  reset();
                "
              ></feather-icon>
            </div>
          </div>
        </div>
        <div class="py-2 pl-4">
          <div v-if="!isMinimize">
            <b> {{ vessel.name }} ({{ vessel.mmsi }})</b>
            <p>MMSI: {{ vessel.mmsi }}</p>
            <p>name: {{ vessel.name }}</p>
            <p>latitude: {{ vessel.latitude }}</p>
            <p>longitude: {{ vessel.longitude }}</p>
            <p>speed over ground: {{ vessel.speed_over_ground }}</p>
            <vs-divider class="mb-0"></vs-divider>
            <!-- <a @click="compare">
              Compare
            </a> -->
          </div>

          <div v-if="!isMinimize" class="vx-row m-2">
            <div class="vx-col w-full pr-2 pl-0">
              <v-date-picker
                :masks="masks"
                :locale="$i18n.locale"
                :buddhist="true"
                :max-date="new Date()"
                :popover="{ placement: 'auto', visibility: 'click' }"
                v-model="selectedDate"
                mode="dateTime"
                is-range
                is24hr
              >
                <template v-slot="{ inputEvents }">
                  <vs-input
                    :value="`${formateDate(
                      selectedDate.start,
                      'start'
                    )} - ${formateDate(selectedDate.end, 'end')}`"
                    label="วันที่"
                    class="w-full"
                    placeholder="วัน/เดือน/ปี - วัน/เดือน/ปี"
                    v-on="inputEvents.start"
                  />
                </template>
              </v-date-picker>
            </div>
            <div class="vx-col w-4/5 pr-2 pl-0">
              <form autocomplete="off" class="w-full">
                <vs-select
                  v-model="selectTimeIntervel"
                  class="w-full select-large"
                  label="ความละเอียดข้อมูล"
                  autocomplete
                >
                  <vs-select-item
                    v-for="(item, index) in intervel"
                    :key="index"
                    :value="item.time"
                    :text="item.name"
                    class="w-full"
                  />
                </vs-select>
              </form>
            </div>
            <div class="vx-col w-1/5 mt-6 pr-4 pl-0" vs-align="left">
              <vs-button
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-search"
                class="w-full"
                @click="search()"
              >
              </vs-button>
            </div>
          </div>

          <div
            v-if="positionReports && positionReports.length > 1"
            class="mt-10"
          >
            <vs-slider
              :min="1"
              :max="positionReports.length"
              v-model="value"
              class="w-1/2"
              color="warning"
              @change="onChange"
            />
          </div>

          <div
            v-if="positionReports && positionReports.length > 1"
            class="vx-row p-2 flex justify-center"
          >
            <div class="mx-1">
              <vs-button
                v-if="!playing"
                color="primary"
                type="filled"
                icon="play_arrow"
                @click="onPlay"
              ></vs-button>
              <vs-button
                v-else
                color="primary"
                type="filled"
                icon="pause"
                @click="onPause"
              ></vs-button>
            </div>
            <div class="mx-1">
              <vs-button
                color="danger"
                type="filled"
                icon="stop"
                @click="onStop"
              ></vs-button>
            </div>
          </div>

          <div
            v-if="!isMinimize && positionReports && positionReports.length > 1"
            class="my-5 flex justify-center"
          >
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-file-text"
              class="w-2/3"
              @click="report()"
            >
              View Report
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ChevronsRightIcon } from "vue-feather-icons";
import vSelect from "vue-select";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import moment from "moment-timezone";

export default {
  name: "WindowHistoryVessel",
  components: {
    VuePerfectScrollbar,
    vSelect,
    ChevronsRightIcon,
    Datepicker,
  },
  props: {
    isHistory: {
      type: Boolean,
      default: false,
    },
    onActive: {
      type: Function,
      default() {},
    },
    onClose: {
      type: Function,
      default() {},
    },
    vessel: {
      type: Object,
      default() {},
    },
    searchHistory: {
      type: Function,
      default() {},
    },
    onChangeValue: {
      type: Function,
      default() {},
    },
    // callback: {
    //   type: Function,
    //   default() {}
    // },
  },
  data() {
    return {
      searchData: {},
      positions: [],
      selectedDate: {
        start: new Date(),
        end: new Date(),
      },
      selectTimeIntervel: 86400,
      tickerTimer: null,
      playing: false,
      value: 1,
      isMinimize: false,
      intervel: [
        {
          id: 1,
          name: "1 minute",
          time: 60,
        },
        {
          id: 2,
          name: "5 minutes",
          time: 300,
        },
        {
          id: 3,
          name: "10 minutes",
          time: 600,
        },
        {
          id: 4,
          name: "15 minutes",
          time: 900,
        },
        {
          id: 5,
          name: "30 minutes",
          time: 1800,
        },
        {
          id: 6,
          name: "1 hour",
          time: 3600,
        },
        {
          id: 7,
          name: "2 hours",
          time: 7200,
        },
        {
          id: 8,
          name: "4 hours",
          time: 14400,
        },
        {
          id: 9,
          name: "6 hours",
          time: 21600,
        },
        {
          id: 10,
          name: "12 hours",
          time: 43200,
        },
        {
          id: 11,
          name: "1 day",
          time: 86400,
        },
        {
          id: 12,
          name: "2 days",
          time: 172800,
        },
      ],
      masks: {
        title: "MMMM YYYY",
        weekdays: "W",
        navMonths: "MMM",
        input: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
        dayPopover: "WWW, MMM D, YYYY",
        data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
      },
    };
  },
  computed: mapState({
    vesselTracking: (state) => state.rts.vesselTracking,
    positionReports: (state) => state.rts.positionReports,
    positionCompareReports: (state) => state.rts.positionCompareReports,
  }),
  watch: {
    positions(val) {
      if (val != 0) {
        this.searchHistory(val, this.vessel);
      }
    },
    value(newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal)) {
        return newVal;
      }
    },
  },
  async mounted() {
    var x,
      y,
      target = null;
    document.addEventListener("mousedown", function (e) {
      var clickedDragger = false;
      for (var i = 0; e.path[i] !== document.body; i++) {
        if (e.path[i].classList.contains("dragger")) {
          clickedDragger = true;
        } else if (
          clickedDragger &&
          e.path[i].classList.contains("draggable")
        ) {
          target = e.path[i];
          target.classList.add("dragging");
          x = e.clientX - target.style.left.slice(0, -2);
          y = e.clientY - target.style.top.slice(0, -2);
          return;
        }
      }
    });
    //<div class="draggable" style="left: 19px; top: 13px;"><div class="dragger flex justify-between"><div class="flex justify-end"><div class="mt-1 mr-2"><span class="cursor-pointer feather-icon select-none relative"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus "><line x1="5" y1="12" x2="19" y2="12"></line></svg></span></div><div class="mt-1"><span class="cursor-pointer feather-icon select-none relative"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x "><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></span></div></div></div><div class="py-2 pl-4"><div><b> A.DEECHOKDEE (567999180)</b><p>MMSI: 567999180</p><p>MID: A.DEECHOKDEE</p><p>latitude: 12.32712</p><p>longitude: 101.3105</p><p>speed over ground: 0.4</p><div class="vs-component vs-divider mb-0"><span class="vs-divider-border after vs-divider-border-default" style="width: 100%; border-top: 1px solid rgba(0, 0, 0, 0.1);"></span><!----><span class="vs-divider-border before vs-divider-border-default" style="width: 100%; border-top: 1px solid rgba(0, 0, 0, 0.1);"></span></div></div><div class="vx-row m-2"><div class="vx-col w-4/5 pr-2 pl-0"><span data-v-380ee0d9="" class="cursor-pointer w-full"><div data-v-380ee0d9="" class="vs-component vs-con-input-label vs-input w-full vs-input-primary"><label for="" class="vs-input--label">วันที่</label><div class="vs-con-input"><input type="text" class="vs-inputx vs-input--input normal hasValue" style="border: 1px solid rgba(0, 0, 0, 0.2);"><!----><!----><!----></div><span></span></div><div data-v-88de91da="" data-v-380ee0d9="" class="vc-popover-content-wrapper"><!----></div></span></div><div vs-align="left" class="vx-col w-1/5 mt-6 pr-4 pl-0"><button type="button" name="button" class="vs-component vs-button w-full vs-button-primary vs-button-filled includeIcon includeIconOnly"><span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span><i class="vs-icon notranslate icon-scale vs-button--icon feather icon-search null" style="order: 0; margin-right: 0px; margin-left: 0px;"></i><!----><span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span></button></div></div><div class="mt-10"><div class="con-vs-slider w-1/2 vs-slider-warning"><button type="button" class="vs-slider"><span class="vs-slider-line-one" style="width: 0%; left: 0%;"></span><span class="vs-slider-line-two"></span><span class="vs-slider-line-efect" style="left: 0%;"></span><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----></button><button type="button" class="vs-circle-slider vs-circles-slider vs-slider--circles vs-slider--circle" style="left: 0%;"><span class="text-circle-slider vs-slider--circle-text"> 0 <!----><i class="vs-icon notranslate icon-scale material-icons null"></i></span></button><!----></div></div><div class="vx-row p-2 flex justify-center"><div class="mx-1"><button type="button" name="button" class="vs-component vs-button vs-button-primary vs-button-filled includeIcon includeIconOnly"><span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span><i class="vs-icon notranslate icon-scale vs-button--icon material-icons null" style="order: 0; margin-right: 0px; margin-left: 0px;">play_arrow</i><!----><span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span></button></div><div class="mx-1"><button type="button" name="button" class="vs-component vs-button vs-button-danger vs-button-filled includeIcon includeIconOnly"><span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span><i class="vs-icon notranslate icon-scale vs-button--icon material-icons null" style="order: 0; margin-right: 0px; margin-left: 0px;">stop</i><!----><span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span></button></div></div></div></div>

    document.addEventListener("mouseup", function () {
      if (target !== null) target.classList.remove("dragging");
      target = null;
    });

    document.addEventListener("mousemove", function (e) {
      if (target === null) return;
      target.style.left = e.clientX - x + "px";
      target.style.top = e.clientY - y + "px";
      var pRect = target.parentElement.getBoundingClientRect();
      var tgtRect = target.getBoundingClientRect();

      if (tgtRect.left < pRect.left) target.style.left = 0;
      if (tgtRect.top < pRect.top) target.style.top = 0;
      if (tgtRect.right > pRect.right)
        target.style.left = pRect.width - tgtRect.width + "px";
      if (tgtRect.bottom > pRect.bottom)
        target.style.top = pRect.height - tgtRect.height + "px";
    });
  },
  created() {},
  methods: {
    formateDate(date, type) {
      if (type == "start") {
        return (
          date &&
          moment(date)
            // .set({ hour: 0, minute: 0 })
            .add(543, "year")
            .format("DD/MM/YYYY HH:mm")
        );
      } else {
        return date && moment(date).add(543, "year").format("DD/MM/YYYY HH:mm");
      }
    },
    async compare() {
      await this.$store.dispatch("rts/getVesselCompareVessel", this.vessel);
      const route = this.$router.resolve({ path: "/compare" });
      window.open(route.href, '_blank');
    },
    async search() {
      this.$vs.loading();
      this.searchData = {
        date: {
          start: moment(this.selectedDate.start)
            // .set({'hour': 0, 'minute': 0})
            .tz("Asia/Bangkok")
            .format("DD/MM/YYYY HH:mm:ss"),
          end: moment(this.selectedDate.end)
            // .add(1, "day")
            .tz("Asia/Bangkok")
            .format("DD/MM/YYYY HH:mm:ss"),
        },
        mmsi: this.vessel.mmsi,
        interval: this.selectTimeIntervel,
      };
      await this.$store.dispatch("rts/getVesselTracking", this.searchData)
      .then(async()=>{
        console.log("vesselTracking ", this.vesselTracking[0]);
        if (this.vesselTracking.length != 0) {
          this.searchData.url = this.vesselTracking[0].url
          await this.$store.dispatch("rts/getVesselHistories", this.searchData);
          if (this.positionReports.length != 0) {
            this.searchHistory(this.positionReports, this.vessel);
          }
        }
      });
      this.$vs.loading.close();
    },
    clearTickerTimer(isStop) {
      // if (this.tickerTimer) {
        clearTimeout(this.tickerTimer);
        this.tickerTimer = null;
        this.playing = false;
        if (isStop == true) {
          this.value = 1;
        }
      // } 
    },
    onTickerTimer() {
      this.tickerTimer = setTimeout(() => {
        this.onTickerTimer();
        if (this.value + 1 <= this.positionReports.length) {
          this.value += 1;
        } else if (this.value + 1 > this.positionReports.length) {
          this.clearTickerTimer(false);
        }
        this.vessel;
      }, 1200);
    },
    onPlay() {
      if (!this.tickerTimer) {
        if (this.value == this.positionReports.length) {
          this.value = 1;
          // this.moveVessel(this.value);
          this.onChangeValue(
            this.value,
            this.positionReports[this.value - 1],
            this.vessel
          );
        }
        this.playing = true;
        this.onTickerTimer();
      }
    },
    onStop() {
      // this.moveVessel(this.value);
      this.onChangeValue(
        this.value,
        this.positionReports[this.value - 1],
        this.vessel
      );
      this.clearTickerTimer(true);
      // this.value = 1;
    },
    onPause() {
      this.clearTickerTimer(false);
    },
    onChange(value) {
      // console.log("value ", this.positionReports.length, value);
      if (value > this.positionReports.length) {
        this.onChangeValue(value, this.positionReports[1], this.vessel);
      } else {
        this.onChangeValue(
          value,
          this.positionReports[value - 1],
          this.vessel
        );
      }
      // this.moveVessel(value);
      // this.callback(value);
    },
    reset() {
      this.selectedDate = {
        start: new Date(),
        end: new Date(),
      };
      this.selectTimeIntervel = 86400;
      this.isMinimize = false;
    },
    report() {
      localStorage.setItem(
        "searchVesselTracking",
        JSON.stringify(this.searchData)
      );
      let routeData = this.$router.resolve({
        name: "vessel_tracking_report_print",
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss">
.draggable {
  width: 335px;
  min-height: 0px;
  background: rgb(250, 250, 250);
  position: relative;
  top: 10%;
  left: 0%;
}

.draggable.dragging {
  user-select: none;
}

.dragger {
  height: 30px;
  background: #555;
  color: #fff;
  cursor: move;
}

.dragger::before {
  content: "History";
  color: #fff;
  margin: 5px;
  display: inline-block;
}

.divHistory {
  position: fixed;
  top: 19%;
  left: 8%;
  right: 0%;
  width: 89.5%;
  height: 100%; //calc(100vh - 0rem);
}

.divMinimize {
  position: fixed;
  bottom: 5%;
  right: 5%;
  width: 23.5%;
  max-height: 18.5%; //calc(100vh - 0rem);
}

.draggableMinimize {
  width: 335px;
  min-height: 0px;
  background: rgb(250, 250, 250);
  position: relative;
  top: 0%;
  left: 0%;
}
</style>
